/* istanbul ignore file */
export { default } from './GoogleMap';
